import { Routes, Route } from "react-router-dom";

// Layouts
import MainLayout from "../components/layouts/MainLayout";

// Core Pages
import Home from "../components/pages/Home";
// import FlightsHub from "../components/pages/FlightsHub";
// import AirlineDetail from "../components/pages/AirlineDetail";
// import CarsHub from "../components/pages/CarsHub";
// import CarDetail from "../components/pages/CarDetail";
// import About from "../components/pages/About";
// import Contact from "../components/pages/Contact";
// import FAQ from "../components/pages/FAQ";

// // Flight Service Pages
// import Support247 from "../components/pages/Support247";
// import FlightDeals from "../components/pages/FlightDeals";
// import GroupTravel from "../components/pages/GroupTravel";
// import SpecialAssistance from "../components/pages/SpecialAssistance";
// import FlightBooking from "../components/pages/FlightBooking";

// // Car Rental Service Pages
// import CarRentalBooking from "../components/pages/CarRentalBooking";
// import AirportCarRental from "../components/pages/AirportCarRental";
// import LuxuryCarRental from "../components/pages/LuxuryCarRental";
// import SUVCarRental from "../components/pages/SUVCarRental";
// import LongTermCarRental from "../components/pages/LongTermCarRental";
// import CarSupport from "../components/pages/CarSupport";

export default function AppRouter() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        {/* Core Nav Pages */}
        <Route path="/" element={<Home />} />
        {/* <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} /> */}

        {/* Flight Hub & Services */}
        {/* <Route path="/flights" element={<FlightsHub />} />
        <Route path="/flights/:airlineSlug" element={<AirlineDetail />} />
        <Route path="/support24x7" element={<Support247 />} />
        <Route path="/flight-deals" element={<FlightDeals />} />
        <Route path="/group-travel" element={<GroupTravel />} />
        <Route path="/special-assistance" element={<SpecialAssistance />} />
        <Route path="/booking" element={<FlightBooking />} /> */}

        {/* Car Hub & Services */}
        {/* <Route path="/cars" element={<CarsHub />} />
        <Route path="/cars/:carSlug" element={<CarDetail />} />
        <Route path="/car/car-rental-booking" element={<CarRentalBooking />} />
        <Route path="/car/airport-car-rental" element={<AirportCarRental />} />
        <Route path="/car/luxury-car-rental" element={<LuxuryCarRental />} />
        <Route path="/car/suv-car-rental" element={<SUVCarRental />} />
        <Route
          path="/car/long-term-car-rental"
          element={<LongTermCarRental />}
        />
        <Route path="/car/24x7-support" element={<CarSupport />} /> */}
      </Route>
    </Routes>
  );
}
